import React from 'react';

import { Modal } from 'src/components/common';
import { VerificationRequestCreateByCvStaffModalForm } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const VerificationRequestCreateByCvStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.VerificationRequestCreateByCVStaff,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Create New Verification Request"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
    >
      <VerificationRequestCreateByCvStaffModalForm
        closeModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
